// On the category lists in archive.twig, set the list to open on tablet up, but closed by default on mobile

export default () => {
  return {
      mounted() {
        let w = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
        if ( w >= 768) { 
            Alpine.data('catList', () => ({
                open: true,
                toggle() {
                    this.open = ! this.open
                },
            }))
        } else {
            Alpine.data('catList', () => ({
                open: false,
                toggle() {
                    this.open = ! this.open
                },
            }))
        }
      }
    }
  }